// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

if (!customElements.get('collection-promo-carousel')) {
  customElements.define(
    'collection-promo-carousel',
    class CtaCarousel extends window.BAO.CustomElement() {
      constructor () {
        super()

        if (this.els.slide.elements.length < 2) return

        this.controlPrevEl = this.querySelector(
          '[data-el="collection-promo-carousel.controlprevious"]',
        )
        this.controlNextEl = this.querySelector(
          '[data-el="collection-promo-carousel.controlnext"]',
        )

        this.carousel = this.initialiseCarousel()

        this.controlPrevEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
        this.controlNextEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
      }

      initialiseCarousel () {
        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'free-snap',
          slidesPerView: 1,
          slides: '.car-Carousel_Slide',
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          slideChanged: instance => {
            const maxClicks =
              instance.details().size - instance.details().slidesPerView

            if (this.controlPrevEl) {
              instance.details().relativeSlide === 0
                ? (this.controlPrevEl.disabled = true)
                : (this.controlPrevEl.disabled = false)
            }

            if (this.controlNextEl) {
              instance.details().relativeSlide >= maxClicks
                ? (this.controlNextEl.disabled = true)
                : (this.controlNextEl.disabled = false)
            }
          },
        })
      }

      onNavClick (event) {
        if (event.currentTarget.dataset.direction === 'previous') {
          this.carousel.prev()
        } else {
          this.carousel.next()
        }
      }
    },
  )
}
